// Görev / alt görev KART RENGİ. Kırmızı gecikme işaretine ayrılmıştır (hazır listede yok, özel renkte reddedilir).
import { useEffect } from "react";
import { api } from "./api";

export const RENKLER = [
  { key: "mavi", ad: "Mavi", hex: "#22d3ee" },
  { key: "lacivert", ad: "Lacivert", hex: "#818cf8" },
  { key: "turkuaz", ad: "Turkuaz", hex: "#2dd4bf" },
  { key: "yesil", ad: "Yeşil", hex: "#4ade80" },
  { key: "acik_yesil", ad: "Açık yeşil", hex: "#a3e635" },
  { key: "haki", ad: "Haki", hex: "#b5b86a" },
  { key: "sari", ad: "Sarı", hex: "#facc15" },
  { key: "altin", ad: "Altın", hex: "#d4a72c" },
  { key: "turuncu", ad: "Turuncu", hex: "#fb923c" },
  { key: "pembe", ad: "Pembe", hex: "#f9a8d4" },
  { key: "fusya", ad: "Fuşya", hex: "#e879f9" },
  { key: "mor", ad: "Mor", hex: "#a78bfa" },
  { key: "lila", ad: "Lila", hex: "#d8b4fe" },
  { key: "kahverengi", ad: "Kahverengi", hex: "#c08a5a" },
  { key: "gri", ad: "Gri", hex: "#94a3b8" },
  { key: "gumus", ad: "Gümüş", hex: "#e2e8f0" },
];
const HARITA = Object.fromEntries(RENKLER.map((r) => [r.key, r]));
export const KIRMIZI_MESAJ = "Kırmızı geciken görevler için ayrılmıştır";

const rgb = (hex) => [1, 3, 5].map((i) => parseInt(hex.slice(i, i + 2), 16));
export const kirmiziMi = (hex) => {
  const [r, g, b] = rgb(hex).map((v) => v / 255);
  const mx = Math.max(r, g, b), mn = Math.min(r, g, b), l = (mx + mn) / 2, d = mx - mn;
  if (!d) return false;
  const s = l > 0.5 ? d / (2 - mx - mn) : d / (mx + mn);
  let h = mx === r ? ((g - b) / d) % 6 : mx === g ? (b - r) / d + 2 : (r - g) / d + 4;
  h = (h * 60 + 360) % 360;
  return (h <= 15 || h >= 345) && s >= 0.35 && l >= 0.18 && l <= 0.85;
};

// Kayıtlı değer → hex (null = varsayılan, renk uygulanmaz).
export const renkHex = (renk) => (!renk || renk === "mavi" ? null : HARITA[renk]?.hex || (/^#[0-9a-f]{6}$/i.test(renk) ? renk : null));
export const renkAdi = (renk) => (!renk ? "Mavi (varsayılan)" : HARITA[renk]?.ad || renk);

const isik = () => typeof document !== "undefined" && !!document.querySelector('[data-testid="aydinlik-interface"]');
const koyulas = (hex, k) => "#" + rgb(hex).map((v) => Math.round(v * k).toString(16).padStart(2, "0")).join("");

// Kart/satır için hafif renk tonu (yazı rengine dokunmaz → okunurluk korunur).
export const renkStili = (renk, acik = isik()) => {
  const hex = renkHex(renk);
  if (!hex) return null;
  const [r, g, b] = rgb(acik ? koyulas(hex, 0.62) : hex);
  return {
    borderColor: `rgba(${r},${g},${b},${acik ? 0.75 : 0.6})`,
    backgroundColor: `rgba(${r},${g},${b},${acik ? 0.1 : 0.09})`,
    boxShadow: acik ? undefined : `0 0 10px rgba(${r},${g},${b},0.16)`,
  };
};

// Açık (Aydınlık) zeminde düz karışım: taban rengin üstüne %oran ton → tek düz renk.
export const renkDolgu = (renk, taban = "#ffffff", oran = 0.1) => {
  const hex = renkHex(renk);
  if (!hex) return null;
  const t = rgb(koyulas(hex, 0.62)), b = rgb(taban);
  return "#" + b.map((v, i) => Math.round(v * (1 - oran) + t[i] * oran).toString(16).padStart(2, "0")).join("");
};

// Renk değişikliği: tek istek (toplu = tek işlem / tek GERİ AL). Listeler olayla yalnız değişen görevi günceller.
export async function renkUygula(hedefler, renk) {
  const r = await api.post("/tasks/renk", { hedefler, renk });
  window.dispatchEvent(new CustomEvent("sertex:task-renk", { detail: r.data.gorevler || [] }));
  return r.data;
}

export function useRenkGuncelleme(setTasks) {
  useEffect(() => {
    const f = (e) => {
      const m = Object.fromEntries((e.detail || []).map((t) => [t.id, t]));
      setTasks((prev) => (prev.some((t) => m[t.id]) ? prev.map((t) => (m[t.id] ? { ...t, renk: m[t.id].renk, subtasks: m[t.id].subtasks, updated_at: m[t.id].updated_at } : t)) : prev));
    };
    window.addEventListener("sertex:task-renk", f);
    return () => window.removeEventListener("sertex:task-renk", f);
  }, [setTasks]);
}
